module.exports = __webpack_public_path__ + "img/image03-right.6349ba9c.png";